import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { StoreService } from '../store.service';
import { AccountService } from './account.service';

@Injectable({
  providedIn: 'root'
})
export class ShopBlockedGuard implements CanActivate {

  constructor(private store: StoreService, private router: Router) {
  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    let aziendaInfo = this.store.aziendaInfo;
    let shopConfig = this.store.shopConfig;
    if (aziendaInfo['blocked'] || shopConfig.isBlocked) {
      if (this.store.unblockedUntil && this.store.unblockedUntil > new Date()) {
        return true;
      }
      else {
        this.router.navigate(['/blocked']);
        return false;
      }
        
    }
    else {
      return true;
    }
  }
}